import React, { useRef, useState } from "react";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";

const KeyValueForm = (props) => {
      const buttonRef = useRef(null);
  const [rows, setRows] = useState([{ key: "", value: "" }]);
  const [errors, setErrors] = useState({});


  // Add a new row
  const handleAddRow = () => {
    setRows([...rows, { key: "", value: "" }]);
  };

// Remove selected row
const handleRemoveRow = (index) => {
    // Remove row
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  
    // Remove corresponding error
    const updatedErrors = { ...errors };
    delete updatedErrors[index];
  
    // Re-index remaining errors
    const newErrorObj = {};
    Object.keys(updatedErrors).forEach((key) => {
      const oldIndex = Number(key);
      newErrorObj[
        oldIndex > index ? oldIndex - 1 : oldIndex
      ] = updatedErrors[key];
    });
  
    setErrors(newErrorObj);
  };
  

  // Handle key/value change
//   const handleChange = (index, field, value) => {
//     const updated = [...rows];
//     updated[index][field] = value;
//     setRows(updated);
//   };
// const handleChange = (index, field, value) => {
//     const updated = [...rows];
//     updated[index][field] = value;
//     setRows(updated);
  
//     // If value is not empty → remove error for this row
//     if (value.trim() !== "") {
//       setErrors(prev => {
//         const newErrors = { ...prev };
//         delete newErrors[index];   // remove error for this specific row
//         return newErrors;
//       });
//     }
//   };
  
const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  
    // Remove specific field error when user types
    setErrors(prev => {
      if (!prev[index]) return prev;
  
      const updatedErrors = { ...prev };
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: value.trim() === "" ? updatedErrors[index][field] : ""
      };
  
      // if both key & value errors empty → delete index error
      if (!updatedErrors[index].key && !updatedErrors[index].value) {
        delete updatedErrors[index];
      }
  
      return updatedErrors;
    });
  };
  
  // Submit all key-value pairs

// const handleSubmit = async () => {
//     try {
//       props.application.setLoading(true);
//       const response = await props.admin.createKeyValue(rows);
  
//       if (response.success) {
//         // If some keys were not added
//         if (response.status_code === 201) {
//           const notAdded = response.data.not_added_configs;
//            const addedIndex=response.data.added_idx
//           // Build error object → { 0: "error msg", 1: "error msg" }
//           const newErrors = {};
//           notAdded.forEach(item => {
//             newErrors[item.index] = item.error;  
//           });
  
//           setErrors(newErrors);
//           props.application.setLoading(false);
//           return; // stop further success actions
//         }
  
//         // Success - no errors
//         toast.success(response.message || "Added Key-Value successfully!", {
//           position: "top-center",
//         });
  
//         setErrors({}); // clear old errors
//         props.application.setLoading(false);
  
//         const button = buttonRef.current;
//         if (button) button.click();
//       } else {
//         toast.error(response.message || "Failed to add data", {
//           position: "top-center",
//         });
//         props.application.setLoading(false);
//       }
  
//     } catch (error) {
//       props.application.setLoading(false);
//       console.error("Error while submitting key-value data:", error);
//       toast.error("Something went wrong while submitting!", {
//         position: "top-center",
//       });
//     }
//   };
const handleSubmit = async () => {
    try {
          // 🔥 VALIDATION FOR EMPTY FIELDS
    let validationErrors = {};
    let hasError = false;

    rows.forEach((row, index) => {
      let msg = "";
      if (!row.key.trim() && !row.value.trim()) {
        msg = "Key and Value are required";
      } else if (!row.key.trim()) {
        msg = "Key is required";
      } else if (!row.value.trim()) {
        msg = "Value is required";
      }

      if (msg) {
        validationErrors[index] = msg;
        hasError = true;
      }
    });

    // ❌ Stop submit if any row invalid
    if (hasError) {
      setErrors(validationErrors);
    //   toast.error("Please fill all required fields!", {
    //     position: "top-center",
    //   });
      return;
    }

    // If all good → clear old errors
    setErrors({});

      props.application.setLoading(true);
      const response = await props.admin.createKeyValue(rows);
  
      if (response.success) {
        if (response.status_code === 201 && response.data.not_added_configs.length !== 0 ) {
          const notAdded = response.data.not_added_configs;
          const addedIdx = response.data.added_idx; // indexes to remove
  
          // Build error object → keeps only problematic rows
          const newErrors = {};
          notAdded.forEach(item => {
            newErrors[item.index] = item.error;
          });
  
          setErrors(newErrors);
  
          // Remove only successful rows
          const updatedRows = rows.filter((row, idx) => !addedIdx.includes(idx));
          setRows(updatedRows);
  
          // Shift errors after removing successful rows
          const shiftedErrors = {};
          Object.keys(newErrors).forEach((key) => {
            const oldIndex = Number(key);
            let newIndex = oldIndex;
  
            // shift error index because some rows removed
            addedIdx.forEach(removed => {
              if (oldIndex > removed) newIndex--;
            });
  
            shiftedErrors[newIndex] = newErrors[key];
          });
  
          setErrors(shiftedErrors);
  
          props.application.setLoading(false);
          return;
        }
  
        // Success (no partial)
        toast.success(response.message || "Added Key-Value successfully!", {
          position: "top-center",
        });
  
        setErrors({});
        props.application.setLoading(false);
  
        const button = buttonRef.current;
        if (button) button.click();
  
      } else {
        toast.error(response.message || "Failed to add data", {
          position: "top-center",
        });
        props.application.setLoading(false);
      }
  
    } catch (error) {
      props.application.setLoading(false);
      console.error("Error while submitting key-value data:", error);
      toast.error("Something went wrong while submitting!", {
        position: "top-center",
      });
    }
  };
  
  

  return (
    <div className="modal fade" id="exampleModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Key-Value </h5>{" "}
            <button
            ref={buttonRef}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={() => {
                setRows([{ key: "", value: "" }]);
                setErrors({});
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div style={{ width: "100%", margin: "20px auto" }}>
              {rows.map((row, index) => (
                <div>
                <div
                  key={index}
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "0px",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="text"
                    className={`form-control ${errors[index] ? "error-border" : ""}`}
                    placeholder="Key"
                    value={row.key}
                    onChange={(e) => handleChange(index, "key", e.target.value)}
                    style={{ flex: 1, padding: "8px" }}
                  />

                  <input
                    type="text"
                    placeholder="Value"
                    className={`form-control ${errors[index] ? "error-border" : ""}`}
                    value={row.value}
                    onChange={(e) =>
                      handleChange(index, "value", e.target.value)
                    }
                    style={{ flex: 1, padding: "8px" }}
                  />
                   {/* Show error below key field */}
    
                  <div className="addmore" style={{ justifyContent: "end" }}>
                    <div className="d-flex">
                      <button onClick={handleAddRow}>+</button>
                      {rows.length > 1 && (
                        <button onClick={() => handleRemoveRow(index)}>
                          -
                        </button>
                      )}
                    </div>
                  </div>
    
                </div>
                {errors[index] && (
      <p style={{ color: "#dc3545", margin: "0 0 0 0" }}>
        {errors[index]}
      </p>
    )}

                </div>
                
                
              ))}
              <button
                onClick={handleSubmit}
                className="btn btn-primary"
                style={{
                  marginTop: "20px",
                }}
              >
                Add Key-Value
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectModels(["admin", "application"])(KeyValueForm);
